import { render, staticRenderFns } from "./ShippingcollectiveRegisterModal.html?vue&type=template&id=0db4b7af&scoped=true&external"
import script from "./ShippingcollectiveRegisterModal.ts?vue&type=script&lang=ts&external"
export * from "./ShippingcollectiveRegisterModal.ts?vue&type=script&lang=ts&external"
import style0 from "./ShippingcollectiveRegisterModal.css?vue&type=style&index=0&id=0db4b7af&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db4b7af",
  null
  
)

export default component.exports